import { MainView } from "../../../views/[domainName]/root";

export default function Component(props) {
    return <MainView />;
}